// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import getJson from '../../services/getJson'
import type { OptionType, ProviderWorkPosition } from '../types'
import MultiSelect from '../controls/MultiSelect'
import LabeledWrapper from './LabeledWrapper'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  width: 480px;
`

type Props = {|
  className: string,
  provider: 'vk' | 'facebook',
  values: Array<ProviderWorkPosition>,
  onChange: (Array<ProviderWorkPosition>) => void
|}

type State = {|
  options: Array<OptionType>,
  isLoading: boolean,
  receivedNotReady: boolean
|}

const t = {
  label: {
    facebook: 'Должности в Facebook',
    vk: 'Должности в ВКонтакте'
  },
  no_results: 'Ничего не найдено',
  placeholder: 'Введите должность'
}

const PROVIDER_POSITION_URLS = {
  vk: '/audiences/vk_positions',
  facebook: '/audiences/fb_positions'
}

export default class ProviderPositionsSelect extends Component<Props, State> {
  debouncedSearch: any
  searchString: any

  constructor(props: Props) {
    super(props)

    this.debouncedSearch = _.debounce(this.search, 500)
    this.searchString = ''

    this.state = {
      options: [],
      isLoading: false,
      receivedNotReady: false
    }
  }

  render() {
    const { options, isLoading, receivedNotReady } = this.state
    const { values, onChange, provider, className } = this.props
    return (
      <LabeledWrapper label={t.label[provider]} twoLines className={className}>
        <Wrapper className={receivedNotReady ? 'not-ready' : ''}>
          <MultiSelect
            placeholder={t.placeholder}
            value={_.map(values, (value) => {
              return JSON.stringify(value)
            })}
            options={options}
            onChange={(positions) => {
              onChange(
                _.map(positions, (position) => {
                  return JSON.parse(position)
                })
              )
            }}
            onInputChange={(q) => {
              this.searchString = q
              this.debouncedSearch()
            }}
            disabled={isLoading}
            noResultsText={t.no_results}
          />
        </Wrapper>
      </LabeledWrapper>
    )
  }

  search() {
    const { provider } = this.props
    const url = PROVIDER_POSITION_URLS[provider]
    let input = this.searchString
    if (!input) return
    this.setState({ options: [], isLoading: true })
    getJson(url, { search: input })
      .done((response) => {
        provider === 'vk' ? this.processVkResponse(response) : this.processFbResponse(response)
      })
      .fail(() => window.alert('Internal error'))
      .always(() => this.setState({ isLoading: false }))
  }

  processFbResponse(response: Object) {
    const positions = this.fbResponseToProviderWorkPosition(response)
    this.processLoadedPositions(positions)
  }

  processLoadedPositions(positions: Array<ProviderWorkPosition>) {
    const options = _.map(positions, (position) => {
      return {
        id: JSON.stringify(position),
        name: position.label
      }
    })
    const valueOptions = _.map(this.props.values, (value) => ({
      id: JSON.stringify(value),
      name: value.label
    }))
    this.setState({
      options: _.sortBy(
        _.uniqBy([...valueOptions, ...options], (option) => option.id),
        (option) => option.name
      )
    })
  }

  processVkResponse(response: Object) {
    if (response['ready']) {
      const positions = this.vkResponseToProviderWorkPosition(response)
      this.processLoadedPositions(positions)
      this.setState({ receivedNotReady: false })
    } else {
      this.setState({ receivedNotReady: true })
      this.debouncedSearch()
    }
  }

  vkResponseToProviderWorkPosition(response: any): Array<ProviderWorkPosition> {
    return _.map(response.positions, (position) => {
      return position.id
    })
  }

  fbResponseToProviderWorkPosition(response: any): Array<ProviderWorkPosition> {
    return _.map(response.result, (position) => {
      return {
        id: position.id,
        label: position.label
      }
    })
  }
}
